import * as All1 from './font_awesome1'
import * as All2 from './font_awesome2'

export const arrowDownIcon = All1.arrowDownIcon;

export const arrowRightIcon = All1.arrowRightIcon;
export const arrowRightActiveIcon = All1.arrowRightActiveIcon;
export const arrowUpIcon = All1.arrowUpIcon;
export const checkIcon = All2.checkIcon;
export const checkIconGreen = All2.checkIconGreen;
export const spinnerIconGray = All1.spinnerIconGray;
export const spinnerIconWhiteBig = All1.spinnerIconWhiteBig;

export const homeIcon = All1.homeIcon;
export const homeActiveIcon = All1.homeActiveIcon; 
export const searchIcon = All1.searchIcon;

export const chevronLeftIcon = All1.chevronLeftIcon;
export const chevronRightIcon = All1.chevronRightIcon;
export const chevronRightIconBlue = All1.chevronRightIconBlue;

export const commonIcon = All1.commonIcon;
export const commonActiveIcon = All1.commonActiveIcon; 
export const userPurgeIcon = All1.userPurgeIcon;
export const userPurgeActiveIcon = All1.userPurgeActiveIcon;
export const userClockIcon = All1.userClockIcon;
export const userClockActiveIcon = All1.userClockActiveIcon;
export const userLockIcon = All1.userLockIcon;
export const userLockActiveIcon = All1.userLockActiveIcon;
export const usersIcon = All1.usersIcon;
export const usersActiveIcon = All1.usersActiveIcon;
export const bellIconBlack = All2.bellIconBlack;
export const bellIconHollow = All2.bellIconHollow;
export const bellIcon = All1.bellIcon;
export const bellActiveIcon = All1.bellActiveIcon;
export const doorOpenIcon = All1.doorOpenIcon;
export const doorOpenActiveIcon = All1.doorOpenActiveIcon;

export const stethoscopeIcon = All1.stethoscopeIcon;
export const stethoscopeActiveIcon = All1.stethoscopeActiveIcon;
export const cogIconBlack = All1.cogIconBlack;
export const cogIcon = All1.cogIcon;
export const cogActiveIcon = All1.cogActiveIcon;
export const loginIcon = All1.loginIcon;
export const loginActiveIcon = All1.loginActiveIcon; 
export const minusIcon = All1.minusIcon;

export const userProfileIcon = All2.userProfileIcon; 

export const fileIcon = All2.fileIcon; 
export const fileActiveIcon = All2.fileActiveIcon; 
export const fileCodeIcon = All2.fileCodeIcon; 

export const copyrightIcon = All2.copyrightIcon; 
export const userIconBlack = All2.userIconBlack;
export const userPageHeadingIcon = All2.userPageHeadingIcon;
 
export const userTieIcon = All1.userTieIcon;
export const userTieActiveIcon = All1.userTieActiveIcon;

export const warningIcon = All1.warningIcon; 
export const warningSmallIcon = All1.warningSmallIcon; 
export const infoIcon = All1.infoIcon; 

export const questionIcon = All2.questionIcon;
export const questionIconSmall = All2.questionIconSmall;

export const auditLogPurgeIcon = All1.auditLogPurgeIcon;
export const auditLogPurgeActiveIcon = All1.auditLogPurgeActiveIcon;

export const paperPlaneIcon = All1.paperPlaneIcon;
export const pauseIcon = All1.pauseIcon;
export const playIcon = All1.playIcon;

export const mobileIcon = All1.mobileIcon;
export const mobileActiveIcon = All1.mobileActiveIcon;

export const envelopeIcon = All1.envelopeIcon;
export const envelopeIconBlack = All2.envelopeIconBlack;
export const envelopeActiveIcon = All1.envelopeActiveIcon;

export const commentIcon = All1.commentIcon;
export const externalLinkIcon = All1.externalLinkIcon;

export const expandIcon = All1.expandIcon;
export const listIcon = All1.listIcon;

export const languageIcon = All1.languageIcon;
export const languageActiveIcon = All1.languageActiveIcon;

export const smileIcon = All1.smileIcon;
export const smileActiveIcon = All2.smileActiveIcon;

export const buildingIcon = All1.buildingIcon;
export const buildingActiveIcon = All1.buildingActiveIcon;

export const fileUploadIcon = All1.fileUploadIcon;
export const fileUploadActiveIcon = All1.fileUploadActiveIcon;
export const fileUploadIconBlack = All1.fileUploadIconBlack;